import React, { useEffect, useState } from "react";
import ProfileDetails from "./ProfileDetails";
import CourseDetails from "./CourseDetails";
import AddressDetails from "./AddressDetails";
import { useDispatch, useSelector } from "react-redux";
import { fetchStudentData } from "../../actions/studentActions";
import LoadingComp from "../LoadingComp";
import TabComp from "../TabComp";

const tabList = {
  "Profile Details": ProfileDetails,
  "Course Details": CourseDetails,
  "Address Details": AddressDetails,
};

const StudentProfileComp = () => {
  const [activeTab, setActiveTab] = useState(Object.keys(tabList)[0]);
  const ActiveComponent = tabList[activeTab];

  const dispatch = useDispatch();
  const { loading, isLoaded, student, error } = useSelector(
    (state) => state.student
  );

  useEffect(() => {
    if (!isLoaded) dispatch(fetchStudentData()); // Fetch student data on component mount
  }, [dispatch, isLoaded]);

  if (loading) {
    return <LoadingComp />;
  }

  if (error) {
    return <div>Error : {error}</div>;
  }

  return (
    <div className="w-full">
      <TabComp
        tabList={tabList}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      {isLoaded && (
        <div className="flex w-full flex-col items-start transition-all duration-500 ease-in-out transform scale-100">
          <ActiveComponent student={student} />
        </div>
      )}
    </div>
  );
};

export default StudentProfileComp;
